import { PayloadAction } from '../../../store.model';
import {
    getSelectedFocusFromRows,
    makeTeamRows,
} from '../focus-history/focus-history.function';
import { ActionType } from '../focus-selector.action';
import { FocusSelectorState } from '../focus-selector.state';

import { FocusSelectorSelectClosedForTeamRow } from './closed-for-team-select.action';

export function focusSelectorSelectClosedForTeamRowReducer(
    state: FocusSelectorState,
    action: PayloadAction<ActionType, FocusSelectorSelectClosedForTeamRow>,
): FocusSelectorState {
    const { rowId } = action.payload;

    const updatedRows = makeTeamRows(state.recentlyClosedFocusesForTeam, rowId);

    const selection = getSelectedFocusFromRows(updatedRows);

    return {
        ...state,
        recentlyClosedFocusesTeamGrid: {
            ...state.recentlyClosedFocusesTeamGrid,
            rows: updatedRows,
            sortDefs: [...state.recentlyClosedFocusesTeamGrid.sortDefs],
            selection,
        },
    };
}
